import {
  Epaysage,
  EpaysageCreateInput,
  EpaysageListResponse,
  EpaysageResponse,
  EpaysageSelectInput,
  EpaysageUpdateInput,
} from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';


export class EpaysageService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.EPAYSAGES?.BASE || '/epaysages', axios);
  }

  async createEpaysage(data: EpaysageCreateInput): Promise<EpaysageResponse> {
    return this.post<EpaysageResponse>('', data);
  }

  async getEpaysages(
    page = 1,
    limit = 10,
    search?: string,
    filters: {
      ville?: string;
      pays?: string;
      area?: number;
    } = {}
  ): Promise<EpaysageListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) params.append('search', search);
    if (filters.ville) params.append('ville', filters.ville);
    if (filters.pays) params.append('pays', filters.pays);
    if (filters.area) params.append('area', filters.area.toString());

    return this.get<EpaysageListResponse>(`?${params.toString()}`);
  }

  async getEpaysage(id: number): Promise<EpaysageResponse> {
    return this.get<EpaysageResponse>(`/${id}`);
  }

  async updateEpaysage(id: number, data: EpaysageUpdateInput): Promise<EpaysageResponse> {
    return this.put<EpaysageResponse>(`/${id}`, data);
  }

  async deleteEpaysage(id: number): Promise<EpaysageResponse> {
    return this.delete<EpaysageResponse>(`/${id}`);
  }

  async selectEpaysages(query: Partial<EpaysageSelectInput>): Promise<{ data: Epaysage[] }> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });

    return this.get<{ data: Epaysage[] }>(`/select?${params.toString()}`);
  }

  async getVilles(): Promise<{ data: string[] }> {
    return this.get<{ data: string[] }>('/villes');
  }

  async getPays(): Promise<{ data: string[] }> {
    return this.get<{ data: string[] }>('/pays');
  }

  async getCoordinates(id: number): Promise<{ data: { lat: number; lng: number }[] }> {
    return this.get<{ data: { lat: number; lng: number }[] }>(`/${id}/coordinates`);
  }

  async updateImage(id: number, field: 'img1' | 'img2' | 'img3', file: File): Promise<EpaysageResponse> {
    const formData = new FormData();
    formData.append('image', file);

    return this.axios
      .patch<EpaysageResponse>(`${this.endpoint}/${id}/update-image/${field}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data);
  }

  async deleteImage(id: number, field: 'img1' | 'img2' | 'img3'): Promise<EpaysageResponse> {
    return this.axios
      .delete<EpaysageResponse>(`${this.endpoint}/${id}/delete-image/${field}`)
      .then((response) => response.data);
  }

  async rotateImage(id: number, field: 'img1' | 'img2' | 'img3', rotation: number): Promise<EpaysageResponse> {
    return this.axios
      .patch<EpaysageResponse>(`${this.endpoint}/${id}/rotate-image/${field}`, { rotation })
      .then((response) => response.data);
  }
}
